<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Benutzer erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.users.store'))">
                <form-fields :form="form" :countries="countries" :accounts="accounts" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
            'accounts',
            'filters',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    account_id: this.filters.account_id || this.accounts[0].id,
                    salutation: null,
                    title: null,
                    first_name: null,
                    last_name: null,
                    email: null,
                    notes: null,
                    avatar: null,
                    password: null,
                    password_confirmation: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>